import EditorCard from './editor-card';

export default EditorCard;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/EditorCard/index.js